<div class="p-10 h-full">
    <nz-page-header class="text-[16px] font-semibold p-0 pb-2 m-0" nzTitle="Razones de tara">
        <nz-page-header-extra class="flex">
            <nz-space>
                <button class="button primary-button" (click)="create()">
                    Añadir
                </button>
            </nz-space>
        </nz-page-header-extra>
    </nz-page-header>

    <nz-table #scrapReasonsTable nzTableLayout="auto" nzSize="small" [nzData]="scrapReasons" [nzLoading]="isLoading"
        [nzLoadingIndicator]="indicatorTemplate" [nzBordered]="true">
        <thead>
            <tr>
                <th nzWidth="300px">Nombre</th>
                <th nzWidth="300px">Causas asignadas</th>
                @if (canRead() || canEdit() || canDelete()) {
                <th nzWidth="200px">Acciones</th>
                }
            </tr>
        </thead>
        <tbody>
            @for (data of scrapReasonsTable.data; track data.id) {
            <tr>
                <td>{{ data.text }}</td>
                <td>{{ data.scrapCauses?.length || 0 }}</td>
                @if (canRead() || canEdit() || canDelete()) {
                <td>
                    <div class="flex align-middle justify-center">
                        @if (canRead()) {
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Ver razón de tara'" nzTooltipPlacement="bottom" nz-tooltip
                            (click)="view(data)">
                            <span nz-icon nzType="eye"></span>
                        </button>
                        @if (canEdit() || canDelete()) {
                        <nz-divider nzType="vertical"></nz-divider>
                        }
                        }

                        @if (canEdit()) {
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Editar razón de tara'" nzTooltipPlacement="bottom" nz-tooltip
                            (click)="edit(data)">
                            <span nz-icon nzType="edit"></span>
                        </button>
                        @if (canDelete()) {
                        <nz-divider nzType="vertical"></nz-divider>
                        }
                        }

                        @if (canDelete()) {
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Eliminar razón de tara'" nzTooltipPlacement="bottom" nz-tooltip
                            (click)="delete(data.id!)">
                            <span nz-icon nzType="delete"></span>
                        </button>
                        }
                    </div>
                </td>
                }
            </tr>
            }
        </tbody>
    </nz-table>
</div>

<ng-template #indicatorTemplate>
    <app-loader></app-loader>
</ng-template>

<nz-drawer [nzClosable]="false" [nzVisible]="drawerVisible" nzPlacement="right" [nzTitle]="title" [nzFooter]="footer"
    (nzOnClose)="closeDrawer()" [nzPlacement]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? 'right':'bottom'"
    [nzWidth]="'500px'" [nzHeight]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? '' : '90%'"
    [nzMaskClosable]="fieldsReadOnly">
    <ng-template #title class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
        <div style="display: flex; align-items: center;">
            <p class="drawer-title"> {{ drawerTitle }} </p>
        </div>
    </ng-template>
    <ng-container *nzDrawerContent>
        <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4">
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-label nzRequired>
                        Nombre de la razón de la tara
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Indique un nombre para la razón de la tara">
                        <input onfocus="select()" nz-input placeholder="Indique un nombre para la causa de la tara"
                            type="text" id="text" formControlName="text" />
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                    <nz-form-label nzRequired>
                        Causas de la tara
                    </nz-form-label>
                    <nz-form-control nzErrorTip="Selecciona las causas vinculadas a la razón de la tara">
                        <nz-select [nzMaxTagCount]="5" [nzMaxTagPlaceholder]="causesSelector" nzMode="multiple"
                            nzPlaceHolder="Selecciona las causas vinculadas a la razón de la tara" id="scrapCauses"
                            formControlName="scrapCauses" [nzDisabled]="fieldsReadOnly" [compareWith]="compareCauses">
                            @for (f of causesDataSet; track f.id) {
                            <nz-option [nzLabel]="f.text" [nzValue]="f"></nz-option>
                            }
                        </nz-select>
                        <ng-template #causesSelector let-selectedList>y {{ selectedList.length }} más
                            seleccionadas</ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </form>
    </ng-container>
    <ng-template #footer>
        <div class="flex justify-end">
            <button class="button secondary-button mr-2" (click)="cancelEditing()">
                Cancelar
            </button>

            @if (!fieldsReadOnly) {
                <button nz-button class="button primary-button" [disabled]="!validateForm.valid" (click)="submitForm()" [nzLoading]="isSaving">
                    Guardar
                </button>
            }
        </div>
    </ng-template>
</nz-drawer>